// This file is deprecated - use the Redux Toolkit store in ../redux/store.tsx instead
// Keeping this for backward compatibility but it's not used in the new architecture

import { configureStore } from '@reduxjs/toolkit';

// Create a minimal store for backward compatibility
const store = configureStore({
  reducer: {
    // Empty reducer for compatibility
  },
});

export { store };
export default { store };
